import { render, staticRenderFns } from "./InsightChart.vue?vue&type=template&id=6c21c384&scoped=true"
import script from "./InsightChart.vue?vue&type=script&lang=ts"
export * from "./InsightChart.vue?vue&type=script&lang=ts"
import style0 from "./InsightChart.vue?vue&type=style&index=0&id=6c21c384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c21c384",
  null
  
)

export default component.exports